import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LogOut, Trophy, User, Home, Zap, Activity } from "lucide-react";
import { Button } from "./ui/button";
import StreakBadges from "./StreakBadges";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const linkCls = ({ isActive }) =>
    `flex items-center gap-1.5 px-3 py-1.5 rounded-full font-semibold text-sm transition ${
      isActive
        ? "bg-cyan-400/10 text-cyan-300 ring-1 ring-cyan-400/40"
        : "text-slate-300 hover:bg-white/5"
    }`;

  return (
    <nav className="sticky top-0 z-50 bg-slate-950/95 backdrop-blur-md border-b border-slate-800/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
        <Link to="/" data-testid="brand-home" className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-xl bg-amber-400/10 ring-1 ring-amber-400/50 flex items-center justify-center">
            <Zap className="w-5 h-5 text-amber-300" />
          </div>
          <span className="font-display font-black text-xl tracking-tight text-neon-amber">PAPERCUT</span>
        </Link>
        <div className="hidden sm:flex items-center gap-1">
          <NavLink to="/play" className={linkCls} data-testid="nav-play">
            <Home className="w-4 h-4" /> Play
          </NavLink>
          <NavLink to="/leaderboard" className={linkCls} data-testid="nav-leaderboard">
            <Trophy className="w-4 h-4" /> Leaderboard
          </NavLink>
          <NavLink to="/profile" className={linkCls} data-testid="nav-profile">
            <User className="w-4 h-4" /> Profile
          </NavLink>
          {user?.is_admin && (
            <NavLink to="/admin" className={linkCls} data-testid="nav-admin">
              <Activity className="w-4 h-4" /> Admin
            </NavLink>
          )}
        </div>
        <div className="flex items-center gap-2">
          {user && (
            <div className="hidden sm:inline-flex items-center gap-2 chip chip-slate" data-testid="user-streak">
              <StreakBadges current={user.current_streak || 0} best={user.best_streak || 0} />
            </div>
          )}
          {user && (
            <div className="flex items-center gap-2">
              <span className="hidden sm:inline text-sm font-semibold text-slate-200" data-testid="username-label">
                {user.username}
                {user.is_guest && <span className="ml-1 text-xs text-amber-300">(guest)</span>}
              </span>
              <Button
                variant="outline"
                size="sm"
                onClick={() => {
                  logout();
                  nav("/");
                }}
                data-testid="logout-btn"
                className="border-slate-700 bg-slate-900 text-slate-200 hover:bg-slate-800 hover:text-white"
              >
                <LogOut className="w-4 h-4" />
              </Button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
